module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "color": "white",
      "margin": "0px 0px -5px 0px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.$t('store_number')) + ": "), _c('b', [_vm._v(_vm._s(_vm.storeNumber))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.refreshDelay),
      expression: "refreshDelay"
    }]
  }, [(_vm.orderList && _vm.orderList.length) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "position": "fixed",
      "height": "88%",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "5px"
    }
  }, [_c('swiper', {
    staticClass: "panel-trans",
    staticStyle: {
      "height": "95%",
      "width": "100%",
      "padding": "10px 0px"
    },
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.orderList), function(order, index) {
    return _c('slide', {
      staticStyle: {
        "height": "25vh"
      }
    }, [_c('div', {
      ref: 'order' + order.checkdetails.chk_num,
      refInFor: true,
      class: {
        'panel': true,
        'panel-default': true,
        'box-shadow': true,
        'panel-trans': _vm.panelAnimation[index],
          'panel-shrinking': _vm.panelShrink[index],
          'panel-fade': _vm.panelFade[index]
      },
      staticStyle: {
        "margin": "0px",
        "padding": "0px",
        "height": "24vh"
      },
      attrs: {
        "name": "panel"
      },
      on: {
        "click": function($event) {
          return _vm.toggleOrderSelect($event, order)
        }
      }
    }, [_c('orderheader', {
      staticClass: "panel-heading",
      staticStyle: {
        "padding": "8px 15px",
        "height": "100%"
      },
      attrs: {
        "recallDisplay": true,
        "checkNum": order.checkdetails.chk_num,
        "revenueType": order.checkdetails.name,
        "firstName": order.checkdetails.first_name,
        "lastName": order.checkdetails.last_name,
        "id": order.checkdetails.id,
        "time": order.checkdetails.displayTime,
        "timeColour": order.checkdetails.timeColour
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1)]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "87%",
      "position": "fixed",
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('h3', {
    staticStyle: {
      "color": "white",
      "margin": "20px"
    }
  }, [_vm._v("\r\n        " + _vm._s(_vm.$t('no_recall_orders')) + "\r\n      ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.refreshDelay),
      expression: "!refreshDelay"
    }],
    staticClass: "row",
    staticStyle: {
      "height": "87%",
      "position": "fixed",
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('h3', {
    staticStyle: {
      "color": "white",
      "margin": "20px"
    }
  }, [_vm._v("\r\n        " + _vm._s(_vm.$t('loading')) + "...\r\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "position": "fixed",
      "bottom": "5px",
      "margin": "0px 0px 0px -1px",
      "width": "100%",
      "z-index": "20"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "0px 20px 0px 0px"
    }
  }, [_c('button', {
    staticClass: "btn btn-lg btn-block btn-success",
    staticStyle: {
      "height": "60px"
    },
    on: {
      "click": function($event) {
        return _vm.gotoMain()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left pull-left",
    staticStyle: {
      "margin": "2px 5px 0px 0px"
    }
  }), _vm._v(_vm._s(_vm.$t('back')) + "\r\n                ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "0px 10px"
    }
  }, [(_vm.orderList && _vm.orderList.length) ? _c('div', {
    staticClass: "btn btn-block btn-lg btn-default button-prev btn-modified pull-right",
    staticStyle: {
      "width": "120px",
      "background-color": "#00ffff"
    },
    attrs: {
      "slot": "button-prev"
    },
    on: {
      "click": function($event) {
        return _vm.deselectOrder()
      }
    },
    slot: "button-prev"
  }, [_c('i', {
    staticClass: "fas fa-chevron-left"
  }), _vm._v(" " + _vm._s(_vm.$t('prev')) + "\r\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-block btn-lg btn-danger",
    staticStyle: {
      "height": "60px",
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.selectedOrder
    },
    on: {
      "click": function($event) {
        return _vm.recallLaunch()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-undo pull-left",
    staticStyle: {
      "margin": "2px 0px 0px 0px"
    }
  }), _vm._v(_vm._s(_vm.$t('recall_order')) + "\r\n                ")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "0px 10px"
    }
  }, [(_vm.orderList && _vm.orderList.length) ? _c('div', {
    staticClass: "btn btn-block btn-lg  btn-default button-next btn-modified",
    staticStyle: {
      "width": "120px",
      "background-color": "#00ffff"
    },
    attrs: {
      "slot": "button-next"
    },
    on: {
      "click": function($event) {
        return _vm.deselectOrder()
      }
    },
    slot: "button-next"
  }, [_vm._v(_vm._s(_vm.$t('next')) + " "), _c('i', {
    staticClass: "fas fa-chevron-right"
  })]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "0px 20px 0px 0px"
    }
  }, [_c('button', {
    staticClass: "btn btn-lg pull-right btn-default",
    staticStyle: {
      "height": "40px",
      "width": "40px",
      "padding": "9px",
      "font-weight": "bold",
      "border-radius": "50%",
      "background-color": "#000",
      "border": "none",
      "color": "#fff"
    },
    attrs: {
      "disabled": _vm.logoutTimeout
    },
    on: {
      "click": function($event) {
        return _vm.gotoInfo()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle pull-left",
    staticStyle: {
      "margin": "2px 5px 0px 0px"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "color": "white",
      "font-size": "larger",
      "font-weight": "bold"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#d9534f"
    }
  }, [_vm._v("KDS - Order Recall")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-994f58d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecallDisplay.vue
// module id = 534
// module chunks = 2